<script setup lang="ts">
import { Auth, Config as ConfigComponents, PageContainer, PageLayout, Version } from '@evac/shared'
</script>

<template>
  <PageLayout class="page-with-sidebar">
    <ConfigComponents.Navigation />
    <!-- Stable gutter: a scrollbar that toggles as live rows change made the page jump. -->
    <PageContainer class="grid grid-rows-[max-content_1fr] [scrollbar-gutter:stable]" data-scope="config">
      <RouterView />
    </PageContainer>
    <template #footer>
      <Version.Info />
    </template>
    <template #nav:post>
      <Auth.LogoutButton />
    </template>
  </PageLayout>
</template>
